import REFERRAL_API from 'api/referral/v1'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import prepareFilterParams from 'utils/prepareFilterParams'
import {
  FINANCIAL_TERMS_FETCH,
  LINKS_CREATE_LINK,
  LINKS_FETCH,
  LINKS_FETCH_LINK,
  LINKS_UPDATE_LINK,
} from 'modules/Referral/ReferralLinks/types'
import { startSubmit, stopSubmit } from 'redux-form'
import isEmpty from 'lodash/isEmpty'
import { actionSetLinks } from 'modules/Referral/ReferralLinks/actions'
import { notificationShow } from 'modules/Notifications/actions'

function* referralLinksFetch({ payload }) {
  const {
    meta: { reject, resolve },
    page = 0,
    ...rest
  } = payload

  const {
    filters,
    data,
    pagination: { limit } = {},
  } = yield select((state) => state['referral/links'])

  try {
    const { response, error } = yield call(REFERRAL_API.fetchLinks, {
      params: prepareFilterParams({
        ...filters,
        offset: (page - 1) * limit,
        limit,
        ...rest,
      }),
    })

    if (error) {
      throw error
    }

    yield put(
      actionSetLinks({
        data: [...(data ?? []), ...response.data],
        pagination: response.pagination,
      }),
    )
    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    reject()
    console.logXHR(error)
  }
}

function* referralLinksUpdateLink({ payload }) {
  const {
    meta: { reject, resolve },
    formName,
    ...rest
  } = payload

  const { data } = yield select((state) => state['referral/links'])

  yield put(startSubmit(formName))

  try {
    const { response, error } = yield call(REFERRAL_API.updateLink, {
      ...rest,
    })

    if (error) {
      throw error
    }

    yield put(
      actionSetLinks({
        data:
          data?.map((link) =>
            link.id === response.data.id ? { ...link, ...response.data } : link,
          ) ?? [],
      }),
    )

    yield put(
      notificationShow({
        type: 'success',
        message: 'referral::referral_links_edit.notifications.success_changed',
        delay: 2000,
      }),
    )

    yield put(stopSubmit(formName))
    resolve()
  } catch (error) {
    const { fields, form } = extractErrors(error.errors)

    if (isEmpty(fields)) {
      yield put(stopSubmit(formName, fields))
      reject()
      return
    }

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    yield put(stopSubmit(formName))
    reject()
    console.logXHR(error)
  }
}

function* referralLinksCreateLink({ payload }) {
  const {
    meta: { reject, resolve },
    formName,
    ...rest
  } = payload

  yield put(startSubmit(formName))

  try {
    const { error } = yield call(REFERRAL_API.createLink, {
      data: rest,
    })

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message:
          'referral::referral_links_create.notifications.success_created',
        delay: 2000,
      }),
    )
    resolve()
    yield put(stopSubmit(formName))
  } catch (error) {
    const { fields, form } = extractErrors(error.errors)

    if (!isEmpty(fields)) {
      yield put(stopSubmit(formName, fields))
      return
    }

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )

    yield put(stopSubmit(formName))
    reject(error)
    console.logXHR(error)
  }
}

function* referralLinksFetchLink({ payload }) {
  const {
    meta: { reject, resolve },
    ...rest
  } = payload

  try {
    const { response, error } = yield call(REFERRAL_API.fetchLink, {
      ...rest,
    })

    if (error) {
      throw error
    }

    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    reject()
    console.logXHR(error)
  }
}

function* financialTermsFetch({ payload }) {
  const {
    meta: { reject, resolve },
  } = payload

  try {
    const { response, error } = yield call(REFERRAL_API.fetchFinancialTerms)

    if (error) {
      throw error
    }

    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    reject()
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(LINKS_FETCH, referralLinksFetch)
  yield takeLatest(LINKS_UPDATE_LINK, referralLinksUpdateLink)
  yield takeLatest(FINANCIAL_TERMS_FETCH, financialTermsFetch)
  yield takeLatest(LINKS_CREATE_LINK, referralLinksCreateLink)
  yield takeLatest(LINKS_FETCH_LINK, referralLinksFetchLink)
}
